import React from 'react'
import { Link } from "react-router-dom";

const SubservientChargesItrUI = ({ context, account, subservientITR, onShowDetailsClick, showDetails }) =>
  <div id='subservientItr' className='g_m_top_200'>
    <span className='g_flex_h'>
      <b className='g_large'>Subservient using ITR</b>
      <Link to='#' onClick={onShowDetailsClick}>Details</Link>
    </span>
    <table className='g_table'>
      <thead className='g_sticky'><tr>
        <td className='g_text_center'><b>Particulars</b></td>
        <td className='g_text_center'><b>From last<br />audited year</b></td>
        <td className='g_text_center'><b>YTD</b></td>
        <td className='g_text_center'><b>RV %</b></td>
        <td className='g_text_center'><b>RV Amount</b></td>
      </tr></thead>
      <tbody>
        <tr><td colSpan='8'><b className='g_m_top_200'>Non-current Assets</b></td></tr>
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='tangibleAssets' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='otherTangibleAssets' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='intangibleAssets' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='capitalWorkInProgress' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='intangibleAssetsUnderDevelopment' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='nonCurrentInvestments' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='longTermLoansAndAdvances' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='deferredTaxAssets' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='otherNonCurrentAssets' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='totalNonCurrentAssets' />
        <tr><td colSpan='8'><b className='g_m_top_200'>Current Assets</b></td></tr>
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='currentInvestments' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='inventories' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='shortTermLoansAndAdvances' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='tradeReceivables' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='cashAndBankBalances' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='otherCurrentAssets' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='totalCurrentAssets' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='totalAssets' />
        <tr><td colSpan='8'><b>Non-current Liabilities</b></td></tr>
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='securedLongTermBorrowings' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='unsecuredLongTermBorrowings' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='longTermProvisions' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='deferredTaxLiabilities' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='otherNonCurrentLiabilities' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='totalNonCurrentLiabilities' />
        <tr><td colSpan='8'><b>Current Liabilities</b></td></tr>
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='securedShortTermBorrowings' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='tradePayables' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='shortTermProvisions' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='currentDeferredTaxLiabilities' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='otherCurrentLiabilities' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='totalCurrentLiabilities' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='totalLiabilities' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='totalChargeValue' />
        {/* <RowUI subservientITR={subservientITR} showDetails={showDetails} name='gstCashProfit' />
        <RowUI subservientITR={subservientITR} showDetails={showDetails} name='promoterContribution' />
        <TotalUI subservientITR={subservientITR} total={true} showDetails={showDetails} name='finalChargeValue' /> */}
      </tbody>
    </table>
  </div>

const RowUI = ({ subservientITR, total, name, showDetails }) =>
  <>
    {
      subservientITR[name + 'Item'] &&
      <>
        <tr className={total && 'g_table_total'}>
          <td><Desc name={name} /></td>
          <td className='g_text_right g_m_left_100'>
            {subservientITR[name + 'Item'].auditedValueF2}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientITR[name + 'Item'].currentValueF2}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientITR[name + 'Item'].rvPercent}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientITR[name + 'Item'].rvAmountF2}
          </td>
        </tr>
        <tr>
          {
            subservientITR[name + 'Item'].formula && showDetails &&
            <td colSpan='5' className='g_muted g_small'>
              {subservientITR[name + 'Item'].formula}
            </td>
          }
        </tr>
      </>
    }
  </>

const TotalUI = ({ subservientITR, total, name, showDetails }) =>
  <>
    {
      subservientITR[name + 'Item'] &&
      <>
        <tr className={total && 'g_table_total'}>
          <td><Desc name={name} /></td>
          <td className='g_text_right g_m_left_100'>
            {subservientITR[name + 'Item'].auditedValueF2}
          </td>
          <td className='g_text_right g_m_left_100'>
            {subservientITR[name + 'Item'].currentValueF2}
          </td>
          <td></td>
          <td className='g_text_right g_m_left_100'>
            {subservientITR[name + 'Item'].rvAmountF2}
          </td>
        </tr>
        <tr>
          {
            subservientITR[name + 'Item'].formula && showDetails &&
            <td colSpan='5' className='g_muted g_small'>
              {subservientITR[name + 'Item'].formula}
            </td>
          }
        </tr>
      </>
    }
  </>

const Desc = ({ name }) =>
  <span>
    {(() => {
      switch (name) {
        case 'equityShareCapital':
          return 'Equity Share Capital'
        case 'otherEquity':
          return 'Other Equity'
        case 'reserveSurplus':
          return 'Reserve & Surplus'
        case 'others':
          return 'Others'
        case 'totalEquity':
          return 'Total Equity'
        case 'securedLongTermBorrowings':
          return 'Secured Long-term Borrowings'
        case 'unsecuredLongTermBorrowings':
          return 'Unsecured Long-term Borrowings'
        case 'longTermProvisions':
          return 'Long Term Provisions'
        case 'deferredTaxLiabilities':
          return 'Deferred Tax Liabilities'
        case 'otherNonCurrentLiabilities':
          return 'Other Non-Current Liabilities'
        case 'totalNonCurrentLiabilities':
          return 'Total Non-Current Liabilities'
        case 'securedShortTermBorrowings':
          return 'Secured Short-term Borrowings'
        case 'tradePayables':
          return 'Trade Payables'
        case 'shortTermProvisions':
          return 'Short Term Provisions'
        case 'currentDeferredTaxLiabilities':
          return 'Current Deferred Tax Liabilities'
        case 'otherCurrentLiabilities':
          return 'Other Current Liabilities'
        case 'totalCurrentLiabilities':
          return 'Total Current Liabilities'
        case 'totalLiabilities':
          return 'Total Liabilities'
        case 'totalEquityAndLiabilities':
          return 'Total Equity and Liabilities'

        case 'tangibleAssets':
          return 'Tangible Assets'
        case 'otherTangibleAssets':
          return 'Other Tangible Assets'
        case 'intangibleAssets':
          return 'Intangible Assets'
        case 'capitalWorkInProgress':
          return 'Capital Work in Progress'
        case 'intangibleAssetsUnderDevelopment':
          return 'Intangible Assets under Development'
        case 'netFixedAssets':
          return 'Net Fixed Assets'
        case 'nonCurrentInvestments':
          return 'Non-current Investments'
        case 'longTermLoansAndAdvances':
          return 'Long Term Loans & Advances'
        case 'deferredTaxAssets':
          return 'Deferred Tax Assets'
        case 'otherNonCurrentAssets':
          return 'Other Non-Current Assets'
        case 'totalNonCurrentAssets':
          return 'Total Non-current Assets'
        case 'currentInvestments':
          return 'Current Investments'
        case 'inventories':
          return 'Inventories'
        case 'shortTermLoansAndAdvances':
          return 'Short Term Loans & Advances'
        case 'tradeReceivables':
          return 'Trade Receivables'
        case 'cashAndBankBalances':
          return 'Cash and Bank Balances'
        case 'otherCurrentAssets':
          return 'Other Current Assets'
        case 'totalCurrentAssets':
          return 'Total Current Assets'
        case 'totalAssets':
          return 'Total Assets'
        case 'totalChargeValue':
          return 'Total Charge Value'
        case 'gstCashProfit':
          return 'GST cash profit'
        case 'promoterContribution':
          return 'Promoter contribution'
        case 'finalChargeValue':
          return 'Final Charge Value'
        default:
          return name
      }
    })()}
  </span>

export default SubservientChargesItrUI
